import { Pagination, Stack } from '@mui/material';

const CustomPagination = (props) => {
  return (
    <Stack alignItems="center" mt={8}>
      <Pagination
        {...props}
        color="primary"
        showFirstButton
        showLastButton
        defaultPage={1}
      />
    </Stack>
  );
};

export default CustomPagination;
